import { Link, useLocation } from "react-router-dom";
import { Pulse, GithubLogo } from "@phosphor-icons/react";

export default function Header() {
  const { pathname } = useLocation();
  const now = new Date().toUTCString().split(" ").slice(1, 5).join(" ");
  return (
    <header
      data-testid="app-header"
      className="border-b border-zinc-800 bg-[#050505] sticky top-0 z-40"
    >
      <div className="flex items-center justify-between px-8 h-14">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <div className="w-8 h-8 border border-white flex items-center justify-center">
            <Pulse size={18} weight="bold" className="text-white" />
          </div>
          <div className="leading-none">
            <div className="font-display text-lg font-black tracking-tighter">
              PULSE
            </div>
            <div className="overline text-[10px]">personal.market.terminal</div>
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          <NavLink to="/" active={pathname === "/"} label="Dashboard" testId="nav-dashboard" />
        </nav>

        <div className="flex items-center gap-4">
          <div className="hidden md:flex flex-col items-end leading-none">
            <span className="overline text-[10px]">UTC</span>
            <span className="tabular text-xs text-white">{now}</span>
          </div>
          <a
            href="https://emergent.sh"
            target="_blank"
            rel="noreferrer"
            data-testid="header-emergent"
            className="border border-zinc-800 hover:border-white p-2 transition-colors"
          >
            <GithubLogo size={14} weight="bold" />
          </a>
        </div>
      </div>
    </header>
  );
}

function NavLink({ to, active, label, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className={`px-3 py-1.5 text-xs uppercase tracking-widest border border-transparent transition-colors ${
        active
          ? "text-white border-white"
          : "text-zinc-500 hover:text-white hover:border-zinc-700"
      }`}
    >
      {label}
    </Link>
  );
}
